import axios from 'axios'
import type {
  CountResponse,
  GroupCreateRequest,
  GroupDetailResponse,
  GroupFilters,
  GroupImportResponse,
  GroupImportRow,
  GroupLinkPoliciesRequest,
  GroupListRequest,
  GroupListResponse,
  GroupPatchRequest,
  GroupResponse,
} from 'types'

export const groupCreate = (request: GroupCreateRequest) =>
  axios.post<GroupResponse>('/api/groups', request).then((res) => res.data)

export const groupGet = (uuid: string) =>
  axios.get<GroupDetailResponse>(`/api/groups/${uuid}`).then((res) => res.data)

export const groupPatch = (uuid: string, request: GroupPatchRequest) =>
  axios
    .patch<GroupDetailResponse>(`/api/groups/${uuid}`, request)
    .then((res) => res.data)

export const groupList = (request: GroupListRequest) =>
  axios
    .get<GroupListResponse>('/api/groups', { params: request })
    .then((res) => res.data)

export const groupCount = (filters?: GroupFilters) =>
  axios
    .get<CountResponse>('/api/groups/count', { params: { filters } })
    .then((res) => res.data)

export const groupDelete = (uuid: string) =>
  axios.delete<void>(`/api/groups/${uuid}`).then((res) => res.data)

export const groupLinkPolicies = (
  groupUuid: string,
  data: GroupLinkPoliciesRequest,
) =>
  axios
    .post<void>(`/api/groups/${groupUuid}/policies`, data)
    .then((res) => res.data)

export const groupUnlinkPolicies = (
  groupUuid: string,
  data: GroupLinkPoliciesRequest,
) =>
  axios
    .delete<void>(`/api/groups/${groupUuid}/policies`, { data })
    .then((res) => res.data)

export const groupImport = (data: GroupImportRow[]) =>
  axios
    .post<GroupImportResponse>('/api/groups/import', { data })
    .then((res) => res.data)

export const GROUP_EXPORT_ENDPOINT = '/api/groups/export'
